import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import SignUpBanner from './components/SignUpBanner';
import PageHeaders from '../../../Utils/PageHeaders';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';
import PartnersSection from '../Home/components/PartnersSection';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
}));

const FinancialAdvisorsPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HubNav />
      <PageHeaders
        title="Retirement Planning Tools for Financial Advisors | Plootus"
        description="Plootus gives financial advisors a powerful dashboard to manage multiple clients' 401(k), 403(b), and 457 retirement plans in one place — with AI-driven allocation recommendations, fee analysis, and real-time portfolio tracking."
        ogTitle="Retirement Planning Platform for Financial Advisors | Plootus"
        ogDescription="Help more clients retire confidently. Plootus lets advisors monitor and optimize multiple retirement accounts from a single dashboard — free to use, no SSN required."
        canonicalUrl="https://www.plootus.com/financial-advisors"
      />
      <HeroSection />
      <FeaturesSection />
      <PartnersSection rootPadding="0px" />
      <SignUpBanner />
    </div>
  );
};

export default FinancialAdvisorsPage;
